import { useSyncExternalStore } from 'react';

import { media_query_store } from '~/_shared/design-system/lib/media-query-store';

// Purpose-built, never a generic `useMediaQuery(query)`: a generic hook
// invites JS-driven styling that belongs in `@media` blocks.

// The shell reads a breakpoint in JS only to swap the aside for Drawer.Body —
// drawer_content's fixed element ids must never be in the DOM twice.

// `lg` is where the drawer becomes a persistent sidebar; `xl` is where a
// second content pane fits beside the first.
const DESKTOP_MEDIA_QUERY = '(min-width: 64rem)';
const WIDE_MEDIA_QUERY = '(min-width: 80rem)';

// Change a width here and the matching `lg:` / `xl:` Tailwind variant in the
// shell's sheets changes with it, or structure and styling desynchronize.

// Desktop-first: Managers work on desktop, so the deterministic SSR / first
// render assumes the widest shell and only a narrow visitor sees one reflow.
const get_server_snapshot = (): boolean => true;

const desktop_store = media_query_store(DESKTOP_MEDIA_QUERY, true);
const wide_store = media_query_store(WIDE_MEDIA_QUERY, true);

const useIsDesktop = (): boolean =>
	useSyncExternalStore(
		desktop_store.subscribe,
		desktop_store.get_snapshot,
		get_server_snapshot,
	);

const useIsWide = (): boolean =>
	useSyncExternalStore(
		wide_store.subscribe,
		wide_store.get_snapshot,
		get_server_snapshot,
	);

export { DESKTOP_MEDIA_QUERY, useIsDesktop, useIsWide, WIDE_MEDIA_QUERY };
